import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import { graphql } from "react-apollo";
import { mutationUpdateLabelTemplate } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import PickerColor from "module-common/PickerColor";
import DeleteButton from "./DeleteButtonWithMutation";
import Toggle from "../common/Toggle";

export default graphql(mutationUpdateLabelTemplate)(
  SortableElement(
    class Row extends Component {
      static propTypes = {
        id: PropTypes.number,
        label: PropTypes.string,
        color: PropTypes.string,
        show: PropTypes.bool,
        refetch: PropTypes.func
      };

      render() {
        const { id, label, color, show, refetch } = this.props;
        return (
          <Wrapper>
            <Handle />
            <PickerColor onColorSelected={this.onChangeColor}>
              <LabelColor color={color} />
            </PickerColor>
            <Label>{label}</Label>
            <Toggle toggled={show} onToggle={this.onToggle} />
            <StyledDeleteButton id={id} refetch={refetch} />
          </Wrapper>
        );
      }

      onChangeColor = async color => {
        const { id, mutate, refetch } = this.props;
        try {
          await mutate({
            variables: { labels: [{ id, color: color.substr(1) }] }
          });
          refetch();
          ShowNotice("label-template-color-success");
        } catch (error) {
          ShowNotice("label-template-color-error");
        }
      };

      onToggle = async toggle => {
        const { id, mutate, refetch } = this.props;
        try {
          await mutate({
            variables: { labels: [{ id, isShown: toggle }] }
          });
          refetch();
          if (toggle) {
            ShowNotice("label-template-toggle-show-success");
          } else {
            ShowNotice("label-template-toggle-hide-success");
          }
        } catch (error) {
          ShowNotice("label-template-toggle-error");
        }
      };
    }
  )
);

const Handle = SortableHandle(() => (
  <Icon name="bar" width={25} height={25} onClick={() => {}} />
));
const Wrapper = styled.div`
  height: 36px;
  display: flex;
  flex: none;
  align-items: center;
  &:not(:first-child):not(:last-child) {
    border: 1px solid ${props => props.theme.panelBorder};
    border-left: none;
    border-right: none;
  }
`;
const LabelColor = styled.div`
  flex: none;
  width: 12px;
  height: 12px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 6px;
  margin-left: 14px;
  margin-right: 14px;
  ${props =>
    props.color &&
    css`
      background-color: ${props.color};
    `};
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;
const Label = styled.div`
  margin-right: auto;
`;
const StyledDeleteButton = styled(DeleteButton)`
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/label-panel/RowWithMutation.js